import React, {Component} from 'react'
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Provider } from 'react-redux';
import {persistStore, getStoredState, purgeStoredState} from 'redux-persist';
import config from '../config';
import MockFetchsHttp from './util/MockFetchHttp';


if(config.getEnvironmentName() !== 'local') {

  Sentry.init({
    dsn: "https://7b9ed642746447039ee60b991e2d734c@o936489.ingest.sentry.io/6382228",
    environment: config.getEnvironmentName(),
    integrations: [new BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

if(config.getEnvironmentName() == 'local') {
     /// HTTP mocks VERY IMPORTANT only local
     let mockFetchsHttp = new MockFetchsHttp();
     mockFetchsHttp.execute();
}

import configureStore from './configureStore'
const store = configureStore();
import routes from 'routes/routes';
import {Router, browserHistory, hashHistory} from 'react-router';
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId:'GTM-KT4GP63' , //config.getEnvironmentName() == 'production' ? 'GTM-KT4GP63' : 'GTM-5SD4C96', //for bwsua,
  events: {
      Pageview: 'Pageview'
  },
  dataLayerName: 'PageDataLayer',
  // auth:'0k7w3pt--nuFT_TxP6HoYQ',
  //  preview:'env-2'
  // dataLayer: {
  //     userId: '001',
  //     userProject: 'project'
  // }
}

if(config.getEnvironmentName()== 'development1') {
   TagManager.initialize(tagManagerArgs)
}
console.log('current version', config.applicationVersion   );


        persistState();

        //  getStoredState({storage: AsyncStorage}, (err, storedState) => {
        //      console.log('storedState',storedState );
        //      if (!_.isUndefined(storedState.appSettingsReducer.version) && config.appVersion > storedState.appSettingsReducer.version) {
        //           purgeStoredState({storage: AsyncStorage}, ['userReducer']).then(() => {
        //              console.log('purge of userReducer completed')
        //              persistState();
        //          }).catch(() => {
        //              persistState();
        //              console.log('purge of userReducer failed')
        //          })
        //      } else{
        //          persistState();
        //      }
        // })
        function persistState() {
            var persistor = persistStore(store, {
                whitelist: [  'userReducer'], blacklist: [
                    'products',
                'adminProducts',
                'sellers',
                'allSellersList',
                'appData',
                'focusAreas'] //,storage: localForage
            }, () => {
              const { userReducer: {
                user: {
                  _id: userId = '',
                  email: email = '',
                  firstName: firstName = '',
                  lastName: lastName = ''
                } = {}
              } = {} } = store.getState() || {}

                ReactDOM.render(
                <Provider store={store}>
                        <Router history={browserHistory} routes={routes}/>
                    </Provider>
                    , document.querySelector('.reactContainer'))
            })
            //persistor.purge(['appSettingsReducer']);

            // persistor.purge(['homeReducer',
            //  'pricingReducer',
            //  'buyerNavReducer',
            //  'tabReducer',
            //  'splashReducer',
            //  'searchReducer',
            //  'checkoutReducer',
            //  'cartReducer',
            //  'focusAreasReducer',
            //  'productsReducer',
            //  'profileReducer'])
        }
